import { useEffect, useState } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { equipamentoPorCodigo } from '../api/equipamento';
import { Carregando, ErroDaApi } from '../ui';

/**
 * O destino da plaqueta: resolve o código patrimonial e abre a ficha.
 *
 * ── Por que existe uma tela só para redirecionar ────────────────────
 *
 * A plaqueta carrega o CÓDIGO, não o uuid — ela fica colada num
 * equipamento por dez anos, e um uuid impresso não diz nada a quem lê
 * sem leitor. Mas a ficha é endereçada por uuid, porque é assim que ela
 * é alcançada de todos os outros lugares do sistema. Alguém tem que
 * traduzir, e o lugar certo é aqui: uma tela que sabe fazer uma coisa e
 * sai de cena.
 *
 * `replace` no lugar de `push`: quem leu o QR e apertou «voltar» quer o
 * leitor de volta, não este passo intermediário.
 */
export function EquipamentoPorCodigoTela() {
  const { codigo = '' } = useParams();
  const ir = useNavigate();
  const [erro, setErro] = useState<unknown>(null);

  useEffect(() => {
    let vivo = true;
    equipamentoPorCodigo(codigo)
      .then((e) => {
        if (!vivo) return;
        ir(`/equipamento/${String(e.equipamento_id)}`, { replace: true });
      })
      .catch((e) => { if (vivo) setErro(e); });
    return () => { vivo = false; };
  }, [codigo, ir]);

  if (erro) {
    return (
      <div>
        <div className="cabeca">
          <h1>{codigo}</h1>
        </div>
        <ErroDaApi erro={erro} />
        <p className="sub">
          O código lido foi <b className="mono">{codigo}</b>. Se a plaqueta
          está gasta, confira o número gravado no equipamento e procure pela
          lista.
        </p>
        <Link to="/equipamentos" className="botao">Ver os equipamentos</Link>
      </div>
    );
  }

  return <Carregando texto={`Abrindo ${codigo}`} />;
}
